package floris.graphics.repo

import floris.graphics.NetworkingConfig
import floris.graphics.models.NetworkResponse
import floris.graphics.models.domain.models.CredentialTokens
import floris.graphics.models.domain.models.toCredentialTokens
import floris.graphics.models.dto.requests.CreateTokenDto
import floris.graphics.models.dto.responses.CredentialsResponse
import floris.graphics.models.dto.responses.ErrorResponse
import floris.graphics.postRequest
import kotlinx.browser.window
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.w3c.dom.Window
import org.w3c.dom.set

object AuthRepo {
    private val oauthUrl = "${NetworkingConfig.baseUrl}/api/oauth"

    @Suppress("TooGenericExceptionThrown")
    suspend fun login(username: String, password: String): CredentialTokens {
        val token = CreateTokenDto(username, password)

        val response: NetworkResponse<CredentialsResponse, ErrorResponse> = postRequest("$oauthUrl/token", token, true)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCredentialTokens()
            is NetworkResponse.ServerError -> throw RuntimeException(response.body?.errorDescription)
            is NetworkResponse.Error -> throw response.error ?: Exception("Unknown error")
        }
    }

    @Suppress("TooGenericExceptionThrown")
    suspend fun refreshToken(): CredentialTokens {
        val tokens = window.localStorage.getItem("tokens") ?: throw IllegalStateException("No tokens found in local storage")
        val credentialTokens = Json.decodeFromString<CredentialTokens>(tokens)

        val bodyMap = mapOf("refresh_token" to credentialTokens.refreshToken)
        val response: NetworkResponse<CredentialsResponse, ErrorResponse> = postRequest("$oauthUrl/refresh", bodyMap)

        return when (response) {
            is NetworkResponse.Success -> response.body.toCredentialTokens().also {
                window.rememberLoggedIn(it)
            }

            is NetworkResponse.ServerError -> throw RuntimeException(response.body?.errorDescription)
            is NetworkResponse.Error -> throw response.error ?: Exception("Unknown error")
        }
    }
}

fun Window.rememberLoggedIn(
    tokens: CredentialTokens
) {
    // TODO [TicketNumber]: TokenManager should be used instead of directly accessing localStorage
    localStorage["tokens"] = Json.encodeToString(tokens)
}
